import * as React from "react";
import { Container } from "./Toaster.styled";
import { observer } from "mobx-react";

interface ToasterProps {}

export const Toaster = observer(({}: ToasterProps) => {
	return <Container></Container>;
});
